var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextFormatRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99995 1.25C9.29792 1.25 9.56763 1.4264 9.68707 1.69939L16.687 17.6994C16.853 18.0789 16.68 18.5211 16.3005 18.6871C15.921 18.8531 15.4788 18.6801 15.3128 18.3006L13.1761 13.4167H4.82379L2.68707 18.3006C2.52104 18.6801 2.07882 18.8531 1.69934 18.6871C1.31985 18.5211 1.14681 18.0789 1.31283 17.6994L8.31282 1.69939C8.43225 1.4264 8.70198 1.25 8.99995 1.25ZM12.5198 11.9167L8.99995 3.87117L5.48004 11.9167H12.5198Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 22C0.25 21.5858 0.585786 21.25 1 21.25H17C17.4142 21.25 17.75 21.5858 17.75 22C17.75 22.4142 17.4142 22.75 17 22.75H1C0.585786 22.75 0.25 22.4142 0.25 22Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5303 1.46967C16.2374 1.17678 15.7626 1.17678 15.4697 1.46967C15.1768 1.76256 15.1768 2.23744 15.4697 2.53033L17.9393 5L15.4697 7.46967C15.1768 7.76256 15.1768 8.23744 15.4697 8.53033C15.7626 8.82322 16.2374 8.82322 16.5303 8.53033L19 6.06066L21.4697 8.53033C21.7626 8.82322 22.2374 8.82322 22.5303 8.53033C22.8232 8.23744 22.8232 7.76256 22.5303 7.46967L20.0607 5L22.5303 2.53033C22.8232 2.23744 22.8232 1.76256 22.5303 1.46967C22.2374 1.17678 21.7626 1.17678 21.4697 1.46967L19 3.93934L16.5303 1.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFormatRemove);
export default __webpack_public_path__ + "static/media/text-format-remove.82ddf5d02b67cbddf04a53e3e24f1640.svg";
export { ForwardRef as ReactComponent };